import React, { Component } from 'react';

import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { SearchActivationDateEnd, SearchActivationDateStart, SearchCommercial, SearchPhone, SearchSystemStatus } from './InputList';
import { Box, Button, Grid } from '@material-ui/core';
import { isEmpty } from 'lodash';
import axios from 'axios';
import { fetchAgents } from '../../../../../../jsx/actions/paygAction'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const firstDayOfYear = new Date(new Date().getFullYear(), 0, 1)

class SearchDrawer extends Component {
    state = { 
        phone: this.props.search.phone,
        actualCommercial: this.props.search.actualCommercial,
        systemStatus : this.props.search.systemStatus,
        timeStart: this.props.search.timeStart || firstDayOfYear,
        timeStop: this.props.search.timeStop,
    }
    componentDidMount = async () => {
        const { AGENTS, commercial } = this.props;
        if( commercial && isEmpty(AGENTS) ){
            await this.props.fetchAgents()
        }
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleChangeDate = (date, field) => {
        this.setState({
            [field]: date
        })
    }

    handleSelect = (option, field) => {
        // let display = field+"Display"

        this.setState({ 
            // [display]: option, 
            [field]: option
        }) 
    }

    handleCheck = (field, value) => {
        
        let list = [].concat(this.state[field]) 
        let idx = list.indexOf(value);        

        if (idx !== -1) {
            list.splice(idx, 1);
        } else {
            list.push(value);
        }
       
        this.setState({                
            [field]: list
        })
    }

    handleSubmit = async () => {
        try {
            this.setState({
                fetching: true
            })
            let data = {
                // start_date: this.state.timeStart || firstDayOfYear, 
                // end_date: this.state.timeStop || new Date(),
                phone: this.state.phone,
                systemStatus: this.state.systemStatus,
                // systemStatus: !isEmpty(this.state.systemStatus) ? this.state.systemStatus.value : "",
                actualCommercial: !isEmpty(this.state.actualCommercial) ? this.state.actualCommercial.value : "",
            }
            console.log('====================================');
            console.log({data});
            console.log('====================================');
            // let res = await axios.post(this.props.url, {data})
            let res = await axios.post("/user/single/filter/infolist", {data},{headers:{}}) 
            
            if(res.data.error == "OK"){
                data.actualCommercial = this.state.actualCommercial
                this.props.handleCloseSearch(res.data.content.boxAssoId, data)
                this.setState({
                    fetching: false
                })
            } else {
                console.log("[ERROR] SUBMIT ", res.data.error);
                this.setState({
                    fetching: false
                })
            }
        } catch (error) {
            console.log('====================================');
            console.log("[ERROR] SUBMIT ", error);
            console.log('====================================');
            this.setState({
                fetching: false
            })
        }
    }
    handleReset = () => {
		this.setState({ 
			searchData: { 
				phone: "",
				systemStatus : [],
				timeStart: "", // firstDayOfYear,
				timeStop: "",
				actualCommercial: []
			}
		})
        this.props.handleClose({ 
            phone: "",
            systemStatus : [],
            timeStart: "", // firstDayOfYear,
            timeStop: "",
            actualCommercial: []
        })
        this.props.handleReset()
	}

    render() {
        console.log('===============STATE=====================');
        console.log(this.state);
        console.log('====================================');
        return (
            <div>
                <SwipeableDrawer
                    anchor="right"
                    open={true}
                    onClose={() => this.props.handleClose(this.state)}
                    // onOpen={setDrawer(true)}                  
                >
                    <Box p={2} style={{ width: "350px"}}>
                        <Box P={1}>
                            Recherche Avancée
                        </Box>
                        {/* <Grid container spacing={1}> */}
                            {this.props.phone &&
                                // <Grid item sm={6} md={4}>
                                    <SearchPhone 
                                        onChange={this.handleChange} 
                                        value={this.state.phone}
                                    />
                                // </Grid>
                            }
                            {this.props.commercial &&
                                // <Grid item sm={6} md={4}>
                                    <SearchCommercial 
                                        onChange={this.handleSelect} 
                                        value={this.state.actualCommercial}
                                        AGENTS={this.props.AGENTS}
                                    />
                                // </Grid>
                            }
                            {this.props.status &&
                                // <Grid item sm={6} md={4}>
                                    <SearchSystemStatus 
                                        onChange={this.handleCheck} 
                                        // onChange={this.handleSelect} 
                                        value={this.state.systemStatus} 
                                    />
                                // </Grid>
                            }
                            {this.props.activationDateStart &&
                                // <Grid item sm={6} md={4}>
                                    <SearchActivationDateStart 
                                        onChange={this.handleChangeDate} 
                                        value={this.state.timeStart}
                                    />
                                // </Grid>
                            }
                            {this.props.activationDateEnd &&
                                // <Grid item sm={6} md={4}>
                                    <SearchActivationDateEnd 
                                        onChange={this.handleChangeDate} 
                                        value={this.state.timeStop} 
                                    />
                                // </Grid>
                            }
                        {/* </Grid> */}
                        
                        {/* <Button onClick={() => this.props.handleClose(data)}>
                            Annuler
                        </Button> */}
                        <Button onClick={this.handleSubmit} variant="contained" color="primary" style={{ width: "100%"}} disabled={this.state.fetching}>
                            Rechercher
                        </Button>
                        <Button onClick={this.handleReset} style={{ width: "100%"}}>
                            Reset
                        </Button>
                    </Box>
                </SwipeableDrawer>
            </div>
        );
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        AGENTS: state.agents.agents,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchAgents,
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps )(SearchDrawer);

